import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./TextEditor.css";
import { ContentState, EditorState } from "draft-js";
import { Padding } from "@mui/icons-material";
function TextEditor({ onSave, initialValue }) {
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [isSave, setIsSave] = useState(false);

  useEffect(() => {
    if (initialValue) {
      const contentState = ContentState.createFromText(initialValue);
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorState(newEditorState);
    }
  }, []);

  const handleEditorChange = (state) => {
    setEditorState(state);
    handleSave(state);
  };

  const handleSave = (editorState) => {
    const contentState = editorState.getCurrentContent();
    // const rawContent = convertToRaw(contentState);
    const textValue = contentState.getPlainText();
    if (textValue) {
      onSave(textValue);
      setIsSave(true);
      setTimeout(() => {
        setIsSave(false);
      }, 1000);
    }
  };
  return (
    <div style={{ position: "relative" }}>
      <div style={{ minHeight: 290 }} className="custom-editor">
        <Editor
          editorState={editorState}
          onEditorStateChange={handleEditorChange}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
        />
      </div>
      {/* <button
        style={{ position: "absolute", bottom: 10, right: 10 }}
        onClick={handleSave}
      >
        Save
      </button> */}
    </div>
  );
}

export default TextEditor;
